import { render } from "./type-text.vue?vue&type=template&id=57f964a8&ts=true"
import script from "./type-text.vue?vue&type=script&lang=ts"
export * from "./type-text.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__